/* eslint-disable jira/filename-case */
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';
import { styled, type StyledProps } from '@compiled/react';
import {
	UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT,
	UNSAFE_DO_NOT_USE_BANNER_HEIGHT,
} from '@jira/design-system__navigation-system/src/PageLayout.tsx';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HelpPanelContainer: ComponentType<
	{
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		css?: Record<any, any>;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	/* oxlint-disable @typescript-eslint/no-explicit-any */
> = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
	styled.div<{ css?: Record<any, any> }>({
		boxSizing: 'border-box',
		flex: 1,
		overflow: 'hidden',
		flexDirection: 'column',
		width: '368px',
		height: '100%',
		position: 'fixed',
	});
/* oxlint-enable @typescript-eslint/no-explicit-any */

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HelpPanelContainerV2: ComponentType<
	{
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		css?: Record<any, any>;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
> = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
	styled(HelpPanelContainer)({
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		height: `calc(100vh - ${UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} - ${UNSAFE_DO_NOT_USE_BANNER_HEIGHT})`,

		backgroundColor: token('elevation.surface.overlay'),
	});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HelpPanelSectionMessageContainer: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
> = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
	styled.div({
		position: 'relative',
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: 0,
		paddingLeft: token('space.200'),
		width: '100%',
		boxSizing: 'border-box',
	});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HelpPanelContentContainer: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
> = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
	styled.div({
		flexGrow: 1,
		minHeight: 0,
		position: 'relative',
		overflowY: 'auto',
		overflowX: 'hidden',
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'nowrap',
		justifyContent: 'flex-start',
		alignContent: 'stretch',
		alignItems: 'flex-start',
	});
